/**
 * Лента событий хаба — макет 17:765: «Недавняя активность».
 *
 * Сервис отдаёт факт (вид события, задача, кто и что), а фразу собирает
 * экран: перевод строки живёт в словаре, а не в базе.
 */
import { projectApi } from '@/api'

import type { V1ActivityEvent, V1ActivityKind } from '@/api/clients/tracker-project'

export interface ActivityEvent {
  kind: V1ActivityKind | ''
  projectKey: string
  issueKey: string
  issueTitle: string
  actorName: string
  /** Что именно произошло: имя колонки, заголовок MR, ветка стенда */
  subject: string
  createdAt: string
}

const toEvent = (event: V1ActivityEvent): ActivityEvent => ({
  kind: event.kind ?? '',
  projectKey: event.projectKey ?? '',
  issueKey: event.issueKey ?? '',
  issueTitle: event.issueTitle ?? '',
  actorName: event.actorName ?? '',
  subject: event.subject ?? '',
  createdAt: event.createdAt ?? '',
})

/** Сколько событий в порции: столько влезает в колонку хаба без прокрутки */
export const ACTIVITY_PAGE = 12

/**
 * Порция событий. Страницами, а не одним большим списком: лента на хабе —
 * сводка последнего, а не журнал, и остальное догружается по кнопке (DEV-1590).
 */
export const listActivity = async (page = 1, perPage = ACTIVITY_PAGE): Promise<ActivityEvent[]> => {
  const { data } = await projectApi.projectServiceListActivity(
    undefined,
    String(page),
    String(perPage),
  )

  return (data.events ?? []).map(toEvent)
}

const KIND_KEYS: Record<string, string> = {
  ACTIVITY_KIND_ISSUE_CREATED: 'created',
  ACTIVITY_KIND_ISSUE_MOVED: 'moved',
  ACTIVITY_KIND_COMMENT: 'comment',
  ACTIVITY_KIND_MR_MERGED: 'merged',
  ACTIVITY_KIND_DEVOPS: 'devops',
}

/** Ключ строки словаря под вид события: `hub.activity.kinds.*`. */
export const kindKey = (kind: ActivityEvent['kind']): string => KIND_KEYS[kind] ?? 'other'
